import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Form, Row, Col, Select } from 'antd';
import FormImport from './FormImport'
import apiToolsAPI from '../../../apis/apiToolsAPI'
import alertMessage from '../../../utils/alertMessage';

@inject('apiToolsStore', 'mappingManagementStore','apiManagementStore')
@observer
class SearchForm extends Component {
  state = {
    directionType:''
  }
  formRef = React.createRef();
  componentDidMount() {
    const { apiToolsStore } = this.props
    apiToolsStore.onChangeResultList([])
    apiToolsStore.onChangeSelectedRowKeys([],[])
  }
  onChange=(value)=>{
    const { mappingManagementStore, apiManagementStore } = this.props
    if(value===undefined){
      this.setState({
        directionType: ''
      })
    }else {
      this.setState({
        directionType: value
      })
    }
    if(value==='INBOUND') {
      apiManagementStore.onSearchApiAction({
        direction: 'INBOUND'
      }, 1 ,2000)
    }else if(value==='OUTBOUND') {
      apiManagementStore.onSearchApiAction({
        direction: 'OUTBOUND'
      }, 1 ,2000)
    }else {
      mappingManagementStore.onSearchAction({}, 1 ,2000)
    }
    this.formRef.current.setFieldsValue({
      id: ''
    })
  }
  handleSearch=()=>{
    const { apiToolsStore } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      apiToolsStore.onSearchTransportationAction(fieldsValue)
    }).catch(err => {
    })
  }
  handleImport=()=>{
    this.setState({
      importModalVisible: true
    })
  }
  handleCancelImport=()=>{
    this.setState({
      importModalVisible: false
    })
  }
  handleExport = () => {
    const { apiToolsStore } = this.props
    const { selectedRows } = apiToolsStore
		if (selectedRows.length !== 0) {
      apiToolsAPI.exportAction({body:selectedRows}).then(res => {
        var blob = new Blob([res.data.data], { type: "text/plain;charset=utf-8" }); //解决中文乱码问题
        blob = new Blob([String.fromCharCode(0xFEFF), blob], { type: blob.type });
        //设置链接
        var link = window.URL.createObjectURL(blob);
        var a = document.createElement("a"); //创建a标签
        a.download = "Transportation.txt"; //设置被下载的超链接目标（文件名）
        a.href = link; //设置a标签的链接
        document.body.appendChild(a); //a标签添加到页面
        a.click(); //设置a标签触发单击事件
        document.body.removeChild(a); //移除a标签
      })
    } else {
      alertMessage.error('Please select a message！')
      return
    }
  }
  render() {
    const { mappingManagementStore, apiManagementStore} = this.props
    const { directionType} = this.state
    const { mappingNames } = mappingManagementStore
    const { apiNames } = apiManagementStore
    return (
      <>
        <Row>
          <Col span={12}>
            <Form ref={this.formRef} labelCol={{ span: 8 }}>
              <Row wrap={true} gutter={[10,10]}>
                <Col span={12}>
                  <Form.Item name='transportationDataType' label='Object Type' labelCol={{span:8}} wrapperCol={{span:16}} rules={[{ required: true, message: 'Please select Object Type.' }]}>
                    <Select placeholder="Please select ..." onChange={this.onChange} allowClear>
                      <Select.Option key='INBOUND' value='INBOUND'>INBOUND </Select.Option>
                      <Select.Option key='OUTBOUND' value='OUTBOUND'>OUTBOUND</Select.Option>
                      <Select.Option key='MAPPING' value='MAPPING'>MAPPING</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name='id' label='Object Name' labelCol={{span:8}} wrapperCol={{span:16}} rules={[{ required: this.state.directionType !== '', message: 'Please select Object Name.'}]}>
                    <Select placeholder="Please select ..." allowClear showSearch disabled={this.state.directionType === ''}>
                      {directionType==='INBOUND'?
                        apiNames.map(item => <Select.Option key={item.apiName} value={item.id}>{item.apiName}</Select.Option>):directionType==='OUTBOUND'?
                        apiNames.map(item => <Select.Option key={item.apiName} value={item.id}>{item.apiName}</Select.Option>):
                          mappingNames.map(item => <Select.Option key={item.id} value={item.id}>{item.mappingType==='REQUEST' ? item.name : item.name + '(' + item.mappingType + ')'}</Select.Option>)
                      }
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col span={12} style={{textAlign: 'right'}}>
            <Button style={{marginRight: 10}} onClick={this.handleSearch} type='primary'>Add</Button>
            <Button style={{marginRight: 10}} onClick={this.handleImport} type='primary'>Import</Button>
            <Button onClick={this.handleExport} type='primary'>Export</Button>
          </Col>
        </Row>
        {this.state.importModalVisible?<FormImport
          modalVisible={this.state.importModalVisible}
          handleCancel={this.handleCancelImport}
        />:null}
      </>
    );
  }
}

export default SearchForm;
